export default "__VITE_ASSET__7a3c8611__"